export default __webpack_public_path__ + "static/updatedesk003-17fd05e2ad546656d090cc85b85c8b98.png";